import { render } from "./PurchaseOrderDetail.vue?vue&type=template&id=0f2cf0da&scoped=true"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"

import "./PurchaseOrderDetail.vue?vue&type=style&index=0&id=0f2cf0da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2cf0da"]])

export default __exports__